const global: any = window
const FormID = 150000001966

export const initHelpDeskSystem = (currentTenant: any, currentUser: any) => {
  const preload = document.createElement('link')
  preload.rel = 'preload'
  preload.as = 'script'
  preload.href = `https://widget.freshworks.com/widgets/${FormID}.js`
  document.head.appendChild(preload)

  global.fwSettings = {
    widget_id: FormID,
  }

  const script = document.createElement('script')
  script.src = `https://widget.freshworks.com/widgets/${FormID}.js`
  script.async = true
  script.defer = true
  document.head.appendChild(script)

  if (typeof global.FreshworksWidget !== 'function') {
    const n: any = function () {
      n.q.push(arguments)
    }
    n.q = []
    global.FreshworksWidget = n
  }

  global.FreshworksWidget('hide', 'launcher')

  setTimeout(() => {
    initDefaultInputData(currentTenant, currentUser)
    global.FreshworksWidget('show', 'launcher')
  }, 1500)
}

const initDefaultInputData = (currentTenant: any, currentUser: any) => {
  if (!currentTenant || !currentUser) {
    return
  }

  global.FreshworksWidget(
    'identify',
    'ticketForm',
    {
      name: currentUser?.name,
      email: currentTenant?.extraProperties?.Email,
    },
    {
      formId: FormID,
    }
  )
}
